import { NgModule , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';

// modules (angular)
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// modules (third-party)
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ModalModule } from 'ngx-bootstrap/modal';

// directives
import { ClickDirective } from './directives/click.directive';
import { CollapseContentDirective, CollapseDirective, CollapseItemDirective } from './directives/collapse.directive';
import { DepartmentsAreaDirective } from './directives/departments-area.directive';
import { DropdownDirective } from './directives/dropdown.directive';
import { FakeSlidesDirective } from './directives/fake-slides.directive';
import { OwlPreventClickDirective } from './directives/owl-prevent-click.directive';

// components
import { AlertComponent } from './components/alert/alert.component';
import { IconComponent } from './components/icon/icon.component';
import { InputNumberComponent } from './components/input-number/input-number.component';
import { LoadingBarComponent } from './components/loading-bar/loading-bar.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { PostCardComponent } from './components/post-card/post-card.component';
import { ProductCardComponent } from './components/product-card/product-card.component';
import { ProductComponent } from './components/product/product.component';
import { QuickviewComponent } from './components/quickview/quickview.component';
import { RatingComponent } from './components/rating/rating.component';


// pipes
import { CurrencyFormatPipe } from './pipes/currency-format.pipe';
import { MinusPipe } from './pipes/minus.pipe';
import {  ShiftPosition } from './pipes/shiftposition.pipe';

import { ProductOptionComponent } from './components/product-option/product-option.component';
import { QuickviewoptionComponent } from './components/quickviewoption/quickviewoption.component';
import { InputNumberSmallComponent } from './components/input-number-small/input-number-small.component';
import { SearchOptionsPipe } from './pipes/searchoptions.pipe';
import { TotopComponent } from './components/totop/totop.component';
import { AvatarUploadComponent } from './components/avatar-upload/avatar-upload.component';


@NgModule({
    declarations: [
        // directives
        ClickDirective,
        CollapseContentDirective,
        CollapseDirective,
        CollapseItemDirective,
        DepartmentsAreaDirective,
        DropdownDirective,
        FakeSlidesDirective,
        OwlPreventClickDirective,
        // components
        AlertComponent,
        IconComponent,
        InputNumberComponent,
        InputNumberSmallComponent,
        LoadingBarComponent,
        PageHeaderComponent,
        PaginationComponent,
        PostCardComponent,
        ProductCardComponent,
        ProductComponent,
        QuickviewComponent,
        RatingComponent,
        // pipes
        ShiftPosition,
        CurrencyFormatPipe,
        ProductOptionComponent,
        QuickviewoptionComponent,
        MinusPipe,
        SearchOptionsPipe,
        TotopComponent,
        AvatarUploadComponent
    ],
    imports: [
        // modules (angular)
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        // modules (third-party)
        CarouselModule,
        ModalModule.forRoot()
    ],
    exports: [
        // directives
        ClickDirective,
        CollapseContentDirective,
        CollapseDirective,
        CollapseItemDirective,
        DepartmentsAreaDirective,
        DropdownDirective,
        FakeSlidesDirective,
        OwlPreventClickDirective,
        // components
        AlertComponent,
        IconComponent,
        InputNumberComponent,
        InputNumberSmallComponent,
        LoadingBarComponent,
        PageHeaderComponent,
        PaginationComponent,
        PostCardComponent,
        ProductCardComponent,
        ProductComponent,
        QuickviewComponent,
        QuickviewComponent,
        QuickviewoptionComponent,
        RatingComponent,
        // pipes
        CurrencyFormatPipe,
        MinusPipe,
        SearchOptionsPipe

    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA] 
})
export class SharedModule { }
